import { toDayKey } from './day-key.js';
import { formatDateIT } from './format.js';

function tripDateKey(trip, field) {
  const raw = trip?.[field] ?? trip?.[field.replace(/_([a-z])/g, (_, c) => c.toUpperCase())];
  return raw?.slice?.(0, 10) ?? null;
}

function daysBetween(fromKey, toKey) {
  const from = new Date(`${fromKey}T12:00:00`);
  const to = new Date(`${toKey}T12:00:00`);
  return Math.round((to - from) / 86400000);
}

/**
 * @returns {{ todayLabel: string, phase: 'upcoming'|'active'|'ended', statusLine: string, daysToStart: number, daysToEnd: number, dayOfTrip: number|null, tripLength: number } | null}
 */
export function getTripTiming(trip, date = new Date()) {
  const startKey = tripDateKey(trip, 'date_start');
  const endKey = tripDateKey(trip, 'date_end');
  if (!startKey || !endKey) return null;

  const todayKey = toDayKey(date);
  const tripLength = daysBetween(startKey, endKey) + 1;

  let phase = 'upcoming';
  if (todayKey > endKey) phase = 'ended';
  else if (todayKey >= startKey) phase = 'active';

  const daysToStart = daysBetween(todayKey, startKey);
  const daysToEnd = daysBetween(todayKey, endKey);
  const dayOfTrip = phase === 'active' ? daysBetween(startKey, todayKey) + 1 : null;

  let statusLine;
  if (phase === 'upcoming') {
    if (daysToStart === 0) statusLine = 'Partenza oggi';
    else if (daysToStart === 1) statusLine = 'Partenza domani';
    else statusLine = `Mancano ${daysToStart} giorni alla partenza`;
  } else if (phase === 'active') {
    if (daysToEnd === 0) statusLine = 'Ultimo giorno di viaggio';
    else if (daysToEnd === 1) statusLine = `Giorno ${dayOfTrip} di ${tripLength} · domani si torna`;
    else statusLine = `Giorno ${dayOfTrip} di ${tripLength} · ancora ${daysToEnd} giorni`;
  } else {
    statusLine = 'Viaggio concluso';
  }

  return {
    todayLabel: formatDateIT(todayKey),
    todayKey,
    phase,
    statusLine,
    daysToStart,
    daysToEnd,
    dayOfTrip,
    tripLength,
  };
}

/** Giorni rimanenti nell'alloggio corrente (incluso oggi). */
export function daysLeftInStay(dateEnd, date = new Date()) {
  if (!dateEnd) return null;
  const todayKey = toDayKey(date);
  const endKey = dateEnd.slice(0, 10);
  if (todayKey > endKey) return 0;
  return daysBetween(todayKey, endKey) + 1;
}
